import { render, staticRenderFns } from "./SAnimalHistorico.vue?vue&type=template&id=747aac16&scoped=true"
import script from "./SAnimalHistorico.vue?vue&type=script&lang=js"
export * from "./SAnimalHistorico.vue?vue&type=script&lang=js"
import style0 from "./SAnimalHistorico.vue?vue&type=style&index=0&id=747aac16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747aac16",
  null
  
)

export default component.exports